<template>
  <div class="news-container">
    <div class="common-title">
      <span>新闻</span>
      <span @click="handle2NewList('news')">更多<van-icon name="arrow"/></span>
    </div>
    <div v-if="news.length" class="news-item-container">
      <div @click="handle2NewDetailById(item)" class="news-item" v-for="item in news" :key="item.id">
        <div class="news-item-info">
          <div class="title van-multi-ellipsis--l2">{{ item.title }}</div>
          <div class="time">{{ item.time | formatDate('MM-dd') }}</div>
        </div>
        <div class="pic-container">
          <img v-if="item.piccover" :src="$isCdn(item.piccover)" alt="" />
          <img v-else src="@/assets/image/rec_1.png" alt="" />
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无新闻"></van-empty>
  </div>
</template>

<script>
export default {
  props: ['news'],
  methods: {
    handle2NewDetailById(item) {
      this.$router.push(`/new/${item.id}`)
    },
    handle2NewList(type) {
      this.$router.push(`/${type}More`)
    }
  }
}
</script>

<style lang="scss" scoped>
.news-container {
  .news-item-container {
    background: #fff;
    border-radius: 6px;
    padding: 14px;
  }
  .news-item-container .news-item {
    padding: 16px 0;
    display: flex;
    align-items: center;
    .news-item-info {
      padding-right: 10px;
      flex: 1;
      .title {
        font-size: 14px;
        color: #303133;
        word-break: break-all;
      }
      .time {
        margin-top: 16px;
        font-size: 12px;
        color: #909399;
      }
    }
    .pic-container {
      width: 84px;
      height: 84px;
      border-radius: 4px;
      flex-shrink: 0;
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}

// common
.common-title {
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &:nth-child(1) {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    &:nth-child(2) {
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
